<template>
    <div class="flex flex-col md:flex-row items-end">
        <div class="w-full md:w-6/12">
            <div class="flex flex-col mb-8">
                <div class="">
                    <span class="block text-shuttle mb-2">{{'Explore our gallery by product and type'|t}}</span>
                </div>
                <div class="">
                    <div class="flex flex-col sm:flex-row sm:-mx-3">
                        <div class="flex-auto sm:mx-3 mb-6 sm:mb-0">
                            <custom-dropdown
                                    v-model.sync="localProduct"
                                    :options="productOptions"
                                    :label="'Select a product'|t"/>
                        </div>
                        <div class="flex-auto sm:mx-3">
                            <custom-dropdown
                                    v-model.sync="localCategory"
                                    :options="categoryOptions"
                                    :label="'Select a type'|t"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import CustomDropdown from "../AlluraUI/CustomDropdown.vue";
    import TextInput from "../AlluraUI/TextInput.vue";

    export default {
        props: {
            categoryOptions: Array,
            productOptions: Array,

            value: Object
        },
        components: {
            TextInput,
            CustomDropdown
        },
        methods: {
            signalChange(e) {
                if (e) {
                    e.preventDefault();
                }
                this.$emit('input', {
                    product: this.localProduct,
                    category: this.localCategory
                });
            }
        },
        watch: {
            localProduct: function () {
                this.signalChange();
            },
            localCategory: function () {
                this.signalChange();
            },
            value: function(newVal) {
                this.localProduct = newVal.product;
                this.localCategory = newVal.category;
            }
        },
        mounted() {
                this.localProduct = this.value.product;
                this.localCategory = this.value.category;
        },
        data() {
            return {
                localProduct: this.value.product,
                localCategory: this.value.category
            }
        },
        name: 'GalleryFilters'
    }
</script>